<template>
  <div class="login-view">
    <div>
      <v-card
        class="px-5 py-8"
        color="background"
        width="480px"
        style="border-radius: 15px"
      >
        <h2 class="mb-4">Selecciona un estudio</h2>

        <div>
          <v-select
            :items="items"
            label="Selecciona"
            item-text="name"
            item-value="number"
            v-model="select"
          ></v-select>
        </div>
        <v-btn
          block
          color="primary"
          :disabled="select == null"
          @click="submitStudio"
        >
          Entrar
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { socketAutoConnectDisabled } from "@/socket";
export default {
  data() {
    return {
      items: [],
      select: null,
    };
  },
  computed: {
    ...mapState(["studio"]),
  },
  methods: {
    ...mapActions(["getStudios"]),
    ...mapMutations(["setStudio"]),
    async submitStudio() {
      await this.setStudio(this.select);
      window.ipcRenderer.saveConfig({
        studio: this.select,
        savepath: null,
      });
      if (!socketAutoConnectDisabled) this.$globalData.socket.connect();
      this.$router.push("/slave")
    },
    async fillStudios() {
        this.items = [];
        const studios = await this.getStudios()
        studios.data.forEach((studio) => {
          if (studio.active == true) {
            const studioNumber = studio.name.charAt(studio.name.length - 1);
            studio.number = Number(studioNumber);
            this.items.push(studio);
          }
        });
      
    },
  },
  async created() {
    this.fillStudios();
    if (this.studio !== null) {
      this.$router.push("/slave")
    }
  },
};
</script>

<style scoped>
.login-view {
  height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>